import React, { FC }                             from "react";
import { Button, Checkbox, Divider, Form, Icon } from "semantic-ui-react";
import DeleteReservationSpecialTime
                                                 from "../../../../application/usecase/reservation/DeleteReservationSpecialTime";
import Date                                      from "../../../../domain/fundamentals/date/Date";
import Time                                      from "../../../../domain/fundamentals/date/Time";
import ReservationBusinessDayType                from "../../../../domain/reservation/ReservationBusinessDayType";
import { ReservationSettingRepository }          from "../../../../domain/reservation/ReservationSettingRepository";
import ReservationSpecialBusinessTime            from "../../../../domain/reservation/ReservationSpecialBusinessTime";
import ReservationSpecialBusinessTimes           from "../../../../domain/reservation/ReservationSpecialBusinessTimes";
import DateSelector                              from "../../common/DateSelector";
import TimeRangeSelector                         from "../../common/TimeRangeSelector";
import ValidatorMessage                          from "../../message/ValidatorMessage";

interface Props {
  specialBusinessTimes: ReservationSpecialBusinessTimes;
  repository: ReservationSettingRepository;
  deleteReservationSpecialTime: DeleteReservationSpecialTime;
}

const ReservationSpecialBusinessTimeDisplay: FC<Props> = (props: Props) => {
  if (props.specialBusinessTimes.isEmpty()) return (<p>特別営業時間の設定がありません。</p>);
  return (
    <>
      <p>設定されている特別営業時間</p>
      <Form>
        {
          props.specialBusinessTimes.toList().map((specialBusinessTime: ReservationSpecialBusinessTime, index: number) => (
            <>
              <Form.Group key={ index }>
                <Form.Field>
                  <label>特別営業日</label>
                  <DateSelector
                    date={ specialBusinessTime.date }
                    onChange={ (value: Date) => props.repository.onChangeSpecialBusinessDate(index, value) }
                  />
                </Form.Field>
                <TimeRangeSelector
                  label="特別営業時間"
                  from={ specialBusinessTime.from }
                  to={ specialBusinessTime.to }
                  onChangeFrom={ (value: Time) => props.repository.onChangeSpecialBusinessTimeFrom(index, value) }
                  onChangeTo={ (value: Time) => props.repository.onChangeSpecialBusinessTimeTo(index, value) }
                />
                <Checkbox
                  label="休業日"
                  style={ {marginTop: "2.3rem"} }
                  checked={ specialBusinessTime.dayType.value === ReservationBusinessDayType.REGULAR_HOLIDAY }
                  onChange={ () => props.repository.onChangeSpecialBusinessDayType(index, specialBusinessTime.dayType.value === ReservationBusinessDayType.REGULAR_HOLIDAY ? ReservationBusinessDayType.BUSINESS_DAY : ReservationBusinessDayType.REGULAR_HOLIDAY) }
                />
                <Button
                  icon={ true }
                  labelPosition="left"
                  negative
                  style={ {marginTop: "1.5rem", marginLeft: "1rem"} }
                  onClick={ () => props.deleteReservationSpecialTime.execute(index, specialBusinessTime.date) }
                >
                  <Icon name="trash"/>
                  削除する
                </Button>
              </Form.Group>
              <ValidatorMessage target={ `specialBusinessTimes[${ index }].dateValid` }/>
              <ValidatorMessage target={ `specialBusinessTimes[${ index }].timeValid` }/>
              { index === 0 && props.specialBusinessTimes.size() === 1 ? null : <Divider/> }
            </>
          ))
        }
      </Form>
    </>
  )
};

export default ReservationSpecialBusinessTimeDisplay;
